








































































































































































































import { Vue, Component } from "vue-property-decorator";
import { dateFormat } from "@/utils/timeFormat";
import {
  staffList,
  getSeleSubjectsList,
  getSelectClassList,
} from "@/api/globalSearch";
import { commentStudentListApi } from "@/api/classroomComment";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "commentInfo",
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    status: -1,
    full_time: -1,
  };
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  classList: any[] = [];
  staffList: any[] = [];
  subjectList: any[] = [];
  effectiveDate: any = {
    disabledDate(date: any) {
      return date > Date.now();
    },
  };

  created() {
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page);
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
    this.getStaffList("");
    this.getSeleSubjectsListFn("");
    this.getSelectClassListFn("");
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.searchInfo.class_id) {
      params.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.lesson_date) {
      params.attend_class_start_time =
        new Date(this.searchInfo.lesson_date[0] + " 00:00:01").getTime() / 1000;
      params.attend_class_end_time =
        new Date(this.searchInfo.lesson_date[1] + " 23:59:59").getTime() / 1000;
    }
    if (this.searchInfo.comment_time) {
      params.comment_start_time =
        new Date(this.searchInfo.comment_time[0] + " 00:00:01").getTime() /
        1000;
      params.comment_end_time =
        new Date(this.searchInfo.comment_time[1] + " 23:59:59").getTime() /
        1000;
    }
    if (this.searchInfo.subject_id) {
      params.subject_id = this.searchInfo.subject_id;
    }
    if (this.searchInfo.staff_id) {
      params.staff_id = this.searchInfo.staff_id;
    }
    if (this.searchInfo.sort_field) {
      params.sort_field = this.searchInfo.sort_field;
    }
    if (this.searchInfo.sort_type) {
      params.sort_type = this.searchInfo.sort_type;
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    commentStudentListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        // console.log("学员点评明细", res);
        res.data.list.forEach((item: any) => {
          item.comment_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(item.comment_time).getTime() * 1000
          );
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getSelectClassListFn(v?: any) {
    getSelectClassList({
      page: 1,
      page_size: 100,
      name: v,
      select_type: 1,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.classList = res.data.list;
      }
    });
  }
  getStaffList(v?: any) {
    staffList({
      page: 1,
      page_size: 100,
      status: 1,
      key_word: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.staffList = res.data.list;
      }
    });
  }
  getSeleSubjectsListFn(v?: any) {
    getSeleSubjectsList({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.subjectList = res.data.list;
      }
    });
  }
  // 模糊搜索 - 班级列表
  handleSearchClass(v: any) {
    this.getSelectClassListFn(v);
  }
  // 班级列表下拉
  handleClassVisible(rest: any) {
    if (rest) {
      this.getSelectClassListFn("");
    }
  }

  // 模糊搜索 - 教师列表
  handleSearchTeacher(v: any) {
    this.getStaffList(v);
  }
  // 教师列表下拉
  handleTeacherVisible(rest: any) {
    if (rest) {
      this.getStaffList("");
    }
  }

  // 模糊搜索 - 科目列表
  handleSearchSubject(v: any) {
    this.getSeleSubjectsListFn(v);
  }
  // 科目列表下拉
  handleSubjectVisible(rest: any) {
    if (rest) {
      this.getSeleSubjectsListFn("");
    }
  }
  // 跳转
  toComment(scope: any) {
    this.$router.push({
      name: "comment",
      query: {
        comment_student_id: scope.row.comment_student_id,
        comment_id: scope.row.comment_id,
        student_id: scope.row.student.student_id,
        name: scope.row.student.name,
        from: "commentInfo",
        page: String(this.page),
        status: "catComment",
      },
    });
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.prop === "lesson_full_start_time") {
      this.searchInfo.sort_field = "lesson_full_start_time";
    }
    if (e.prop === "comment_time") {
      this.searchInfo.sort_field = "comment_time";
    }
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
